import { ref } from 'vue'

export const showDeliveryZones = ref(false)
